import { http } from ".";

export const WorkflowActionsService = {
  getWorkflowList: () => {
    return http.get(
      `/workflowtask/GetWorkflowTaskList`
    );
  },
};
